import React from 'react';

// Estilos globales (titulo_solicitud, .row, btn_solicitud…) que todavía usan otras vistas
import "./SolicitudReinscripcion.css"

import VistaSolicitudes from '../../Compartidas/VistaSolicitudes';

import reinscripcionesDataHelper from '../../../Helpers/ReinscripcionesData';
import { LICENCIATURAS_REINSCRIPCION } from '../../../Helpers/solicitudes';

const extraFila = solicitud => [solicitud.cuatrimestre && solicitud.cuatrimestre + ' cuatrimestre', solicitud.grupo && 'grupo ' + solicitud.grupo].filter(Boolean).join(', ');

const SolicitudReinscripcion = () => (
    <VistaSolicitudes
        helper={reinscripcionesDataHelper}
        encabezado='Solicitudes de reinscripción'
        licenciaturas={LICENCIATURAS_REINSCRIPCION}
        rutaDetalle='/solicitud-reinscripcion/'
        extraFila={extraFila}
    />
);

export default SolicitudReinscripcion;
